import { render, staticRenderFns } from "./SensorInfo.vue?vue&type=template&id=896f2006&scoped=true&"
import script from "./SensorInfo.vue?vue&type=script&lang=js&"
export * from "./SensorInfo.vue?vue&type=script&lang=js&"
import style0 from "./SensorInfo.vue?vue&type=style&index=0&id=896f2006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896f2006",
  null
  
)

export default component.exports